/* Titan League · la fruta vuela al carrito */
(function () {
  if (window.TitanFX && window.TitanFX.flyToCart) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GOLD = '#ffd228', VIOLET = '#a855ff';
  var DUR = 3400;

  var css = function (n, s) { for (var k in s) n.style[k] = s[k]; return n; };
  var mk = function (t, s, p) { var n = document.createElement(t); css(n, s || {}); if (p) p.appendChild(n); return n; };
  var anim = function (n, f, o) { try { return n.animate(f, o); } catch (e) { return { onfinish: null }; } };

  function spark(x, y, color, size) {
    var d = mk('i', {
      position: 'fixed', left: x + 'px', top: y + 'px', width: size + 'px', height: size + 'px',
      borderRadius: '50%', background: color, boxShadow: '0 0 14px ' + color,
      pointerEvents: 'none', zIndex: '2147483629'
    }, document.body);
    anim(d, [
      { opacity: 1, transform: 'scale(1)' },
      { opacity: 0, transform: 'scale(.2) translateY(' + (10 + Math.random() * 20) + 'px)' }
    ], { duration: 520 + Math.random() * 300, easing: 'ease-out', fill: 'forwards' });
    setTimeout(function () { d.remove(); }, 900);
  }

  function ring(x, y, color, from, to, ms) {
    var r = mk('i', {
      position: 'fixed', left: x + 'px', top: y + 'px', width: from + 'px', height: from + 'px',
      marginLeft: (-from / 2) + 'px', marginTop: (-from / 2) + 'px',
      borderRadius: '50%', border: '3px solid ' + color, pointerEvents: 'none', zIndex: '2147483628'
    }, document.body);
    anim(r, [
      { opacity: .95, transform: 'scale(1)' },
      { opacity: 0, transform: 'scale(' + (to / from) + ')' }
    ], { duration: ms, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
    setTimeout(function () { r.remove(); }, ms + 120);
  }

  function flyToCart(srcEl, imgUrl) {
    if (!imgUrl) return;
    var target = document.querySelector('.header__icon--cart, #cart-icon-bubble, a[href="/cart"]');
    var to = target ? target.getBoundingClientRect() : { left: innerWidth - 44, top: 34, width: 22, height: 22 };
    var tx = to.left + to.width / 2, ty = to.top + to.height / 2;

    if (reduce) {
      if (target) anim(target, [{ transform: 'scale(1)' }, { transform: 'scale(1.3)', offset: .4 }, { transform: 'scale(1)' }], { duration: 400 });
      return;
    }

    var from = srcEl ? srcEl.getBoundingClientRect() : { left: innerWidth / 2 - 60, top: innerHeight / 2 - 60, width: 120, height: 120 };
    var x0 = from.left + from.width / 2, y0 = from.top + from.height / 2;
    var cx = innerWidth / 2, cy = innerHeight * 0.42;
    var dxc = cx - x0, dyc = cy - y0;
    var dx = tx - x0, dy = ty - y0;

    var halo = mk('div', {
      position: 'fixed', left: (cx - 150) + 'px', top: (cy - 150) + 'px', width: '300px', height: '300px',
      borderRadius: '50%', pointerEvents: 'none', zIndex: '2147483627', opacity: '0',
      background: 'radial-gradient(circle,' + VIOLET + '66 0%,transparent 70%)', filter: 'blur(14px)'
    }, document.body);
    anim(halo, [
      { opacity: 0, transform: 'scale(.5)' },
      { opacity: 1, transform: 'scale(1)', offset: .2 },
      { opacity: .9, transform: 'scale(1.06)', offset: .62 },
      { opacity: 0, transform: 'scale(.4)', offset: .85 },
      { opacity: 0, transform: 'scale(.4)' }
    ], { duration: DUR, easing: 'ease-in-out', fill: 'forwards' });
    setTimeout(function () { halo.remove(); }, DUR + 200);

    var fly = mk('img', {
      position: 'fixed', left: (x0 - 70) + 'px', top: (y0 - 70) + 'px', width: '140px', height: '140px',
      objectFit: 'contain', pointerEvents: 'none', zIndex: '2147483630',
      filter: 'drop-shadow(0 12px 18px rgba(0,0,0,.6)) drop-shadow(0 0 22px ' + VIOLET + ')'
    }, document.body);
    fly.src = imgUrl;
    fly.alt = '';

    anim(fly, [
      { transform: 'translate(0,0) scale(.55) rotate(0deg)', opacity: 0, offset: 0 },
      { transform: 'translate(' + dxc * .5 + 'px,' + (dyc * .5 - 40) + 'px) scale(1.25) rotate(25deg)', opacity: 1, offset: .12 },
      { transform: 'translate(' + dxc + 'px,' + dyc + 'px) scale(1.1) rotate(0deg)', opacity: 1, offset: .22 },
      { transform: 'translate(' + dxc + 'px,' + (dyc - 14) + 'px) scale(1.16) rotate(180deg)', opacity: 1, offset: .42 },
      { transform: 'translate(' + dxc + 'px,' + dyc + 'px) scale(1.1) rotate(360deg)', opacity: 1, offset: .6 },
      { transform: 'translate(' + dxc + 'px,' + (dyc - 26) + 'px) scale(1.3) rotate(380deg)', opacity: 1, offset: .7 },
      { transform: 'translate(' + (dx * .45) + 'px,' + (dy * .45 - 150) + 'px) scale(.8) rotate(620deg)', opacity: 1, offset: .88 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.18) rotate(900deg)', opacity: 1, offset: 1 }
    ], { duration: DUR, easing: 'cubic-bezier(.4,.05,.3,1)', fill: 'forwards' });

    var t0 = performance.now(), raf;
    (function trail(now) {
      var p = Math.min(((now || performance.now()) - t0) / DUR, 1);
      var r = fly.getBoundingClientRect();
      var px = r.left + r.width / 2, py = r.top + r.height / 2;
      if (p > .05 && Math.random() < (p > .7 ? .9 : .45)) {
        spark(px + (Math.random() * 26 - 13), py + (Math.random() * 26 - 13),
          Math.random() < .5 ? GOLD : VIOLET, 4 + Math.random() * 5);
      }
      if (p < 1) raf = requestAnimationFrame(trail);
    })();

    setTimeout(function () { ring(cx, cy, VIOLET, 60, 420, 900); }, DUR * .2);
    setTimeout(function () { ring(cx, cy, GOLD, 50, 340, 800); }, DUR * .42);
    setTimeout(function () { ring(cx, cy, VIOLET, 70, 500, 700); }, DUR * .66);

    setTimeout(function () {
      cancelAnimationFrame(raf);
      fly.remove();
      if (!target) return;
      anim(target, [
        { transform: 'scale(1)' },
        { transform: 'scale(1.45) rotate(-8deg)', offset: .35 },
        { transform: 'scale(.92) rotate(4deg)', offset: .6 },
        { transform: 'scale(1)' }
      ], { duration: 620, easing: 'cubic-bezier(.2,1.6,.4,1)' });
      ring(tx, ty, GOLD, 16, 150, 700);
      for (var i = 0; i < 14; i++) spark(tx + (Math.random() * 40 - 20), ty + (Math.random() * 40 - 20), Math.random() < .5 ? GOLD : VIOLET, 4 + Math.random() * 4);
      var plus = mk('span', {
        position: 'fixed', left: tx + 'px', top: (ty - 10) + 'px', transform: 'translate(-50%,-50%)',
        color: GOLD, font: '900 20px/1 Inter,system-ui,sans-serif', textShadow: '0 2px 10px #000',
        pointerEvents: 'none', zIndex: '2147483631'
      }, document.body);
      plus.textContent = '+1';
      anim(plus, [
        { opacity: 0, transform: 'translate(-50%,-50%) scale(.6)' },
        { opacity: 1, transform: 'translate(-50%,-140%) scale(1.15)', offset: .4 },
        { opacity: 0, transform: 'translate(-50%,-240%) scale(1)' }
      ], { duration: 900, easing: 'ease-out', fill: 'forwards' });
      setTimeout(function () { plus.remove(); }, 950);
    }, DUR);
  }

  window.TitanFX = window.TitanFX || {};
  window.TitanFX.flyToCart = flyToCart;
})();
